import React from 'react';
import { MenuItem } from './MenuItem';
import {
    FaBox,
    FaBuilding,
    FaChartBar,
    FaChartLine,
    FaCheck,
    FaClipboardList,
    FaCreditCard,
    FaFileContract,
    FaFileExport,
    FaFileInvoiceDollar,
    FaFilter,
    FaInstagram,
    FaMailBulk,
    FaReply,
    FaSearch,
    FaSitemap,
    FaUniversalAccess,
    FaUserFriends,
    FaUserShield,
    FaUserTie,
} from 'react-icons/fa';
import { SubMenuItem } from './SubMenuItem';
import { IoGitPullRequestSharp } from 'react-icons/io5';
import { hasAccessRight } from '../../../../utils/Functions';
import { AdminAclEnum } from '../../../../enum/AdminAclEnum';

export function AsideMenuList({ layoutProps }: any) {
    return (
        <ul role="menubar" className={`menu-nav ${layoutProps.ulClasses}`}>
            {hasAccessRight(AdminAclEnum.CAMPAIGNS) && (
                <MenuItem url={''} name={'Campaigns'} icon={<FaBox />} isSubMenu={true} data-cy="menu-campaigns-all">
                    <SubMenuItem url={'/campaign/list'} name={'Campaigns'} data-cy="menu-campaigns" />
                    <SubMenuItem url={'/campaign/goals'} name={'Campaign goals'} data-cy="menu-campaign-goal" />
                    <SubMenuItem url={'/campaign/types'} name={'Campaign types'} data-cy="menu-campaign-types" />
                    <SubMenuItem
                        url={'/campaign/budget-range'}
                        name={'Campaign budget range'}
                        data-cy="menu-campaign-budget-range"
                    />
                </MenuItem>
            )}
            {hasAccessRight(AdminAclEnum.SUPERVISORS) && (
                <MenuItem url={'/supervisors'} name={'Supervisors'} icon={<FaUserTie />} data-cy="menu-supervisors" />
            )}
            {hasAccessRight(AdminAclEnum.INFLUENCER_FEE_OVERVIEW) && (
                <MenuItem
                    url={'/user/influencers/fee'}
                    name={'Influencers with fee'}
                    icon={<FaUserTie />}
                    data-cy="menu-influencers-fee"
                />
            )}
            {(hasAccessRight(AdminAclEnum.OFFERS) ||
                hasAccessRight(AdminAclEnum.OFFER_PDFS) ||
                hasAccessRight(AdminAclEnum.OFFER_EVENT_TRANSFER)) && (
                <MenuItem url={''} name={'Offers'} icon={<FaCheck />} isSubMenu={true} data-cy="menu-offers-all">
                    {hasAccessRight(AdminAclEnum.OFFERS) ? (
                        <SubMenuItem url={'/offers'} name={'Offers'} data-cy="menu-offers" />
                    ) : (
                        <></>
                    )}
                    {hasAccessRight(AdminAclEnum.OFFER_PDFS) ? (
                        <SubMenuItem url={'/offer-pdfs'} name={'Offer PDFs'} data-cy="menu-offer-pdfs" />
                    ) : (
                        <></>
                    )}
                    {hasAccessRight(AdminAclEnum.OFFER_EVENT_TRANSFER) ? (
                        <SubMenuItem
                            url={'/offer-event-transfer'}
                            name={'Event transfer'}
                            data-cy="menu-offer-event-transfer"
                        />
                    ) : (
                        <></>
                    )}
                </MenuItem>
            )}
            {(hasAccessRight(AdminAclEnum.CONTRACTS) || hasAccessRight(AdminAclEnum.CONTRACT_PDFS)) && (
                <MenuItem
                    url={''}
                    name={'Contracts'}
                    icon={<FaFileContract />}
                    isSubMenu={true}
                    data-cy="menu-contracts-all"
                >
                    {hasAccessRight(AdminAclEnum.CONTRACTS) ? (
                        <SubMenuItem url={'/contracts'} name={'Contracts'} data-cy="menu-contracts" />
                    ) : (
                        <></>
                    )}
                    {hasAccessRight(AdminAclEnum.CONTRACT_PDFS) ? (
                        <SubMenuItem url={'/contract-pdfs'} name={'Contract PDFs'} data-cy="menu-contract-pdfs" />
                    ) : (
                        <></>
                    )}
                </MenuItem>
            )}
            {hasAccessRight(AdminAclEnum.ACCESS_RIGHTS) && (
                <MenuItem
                    url={'/access-right'}
                    name={'Sharing Rights'}
                    icon={<FaUniversalAccess />}
                    data-cy="menu-acl"
                />
            )}
            {hasAccessRight(AdminAclEnum.BRAND_USER_ACCESS_RIGHTS) && (
                <MenuItem
                    url={'/brand-acess-rights'}
                    name={'Position Access rights'}
                    icon={<FaUserShield />}
                    data-cy="menu-acl"
                />
            )}
            {hasAccessRight(AdminAclEnum.PACKAGES) && (
                <MenuItem url={''} name={'Packages'} icon={<FaSitemap />} isSubMenu={true} data-cy="menu-packages-all">
                    <SubMenuItem url={'/packages/packages'} name={'Packages'} data-cy="menu-packages" />
                    <SubMenuItem url={'/packages/log'} name={'Packages logs'} data-cy="menu-packages-log" />
                </MenuItem>
            )}
            {hasAccessRight(AdminAclEnum.EXPORT) && (
                <MenuItem url={''} name={'Export'} icon={<FaFileExport />} isSubMenu={true} data-cy="menu-export-all">
                    <SubMenuItem url={'/export/export-offers'} name={'Offers'} data-cy="menu-export-offers" />
                </MenuItem>
            )}
            {hasAccessRight(AdminAclEnum.EMAILING) && (
                <MenuItem
                    url={'/campaign/emailing'}
                    name={'Campaign emailing'}
                    icon={<FaMailBulk />}
                    data-cy="menu-campaign-emailing"
                />
            )}
            {hasAccessRight(AdminAclEnum.BUDGET) && (
                <MenuItem
                    url={'/campaign/budget'}
                    name={'Budget overview'}
                    icon={<FaCreditCard />}
                    data-cy="menu-budget-overview"
                />
            )}
            {/* {hasAccessRight(AdminAclEnum.AGENCY) && (
                <MenuItem url="/agency" name={'Agency companies'} icon={<FaUserFriends />} data-cy="menu-agency" />
            )} */}
            {hasAccessRight(AdminAclEnum.AGENCY) && (
                <MenuItem
                    url={''}
                    name={'Influencer Managements'}
                    isSubMenu={true}
                    icon={<FaUserFriends />}
                    data-cy="menu-agency"
                >
                    <SubMenuItem url={'/agency/overview'} name="Overview" />
                    <SubMenuItem url={'/agency/requested-influencers'} name="Requested Influencers" />
                </MenuItem>
            )}
            {hasAccessRight(AdminAclEnum.ONBOARDING) && (
                <MenuItem
                    url="/onboarding-requests"
                    name="Onboarding requests"
                    icon={<IoGitPullRequestSharp />}
                    data-cy="menu-onboarding"
                />
            )}
            {hasAccessRight(AdminAclEnum.STATISTICS) && (
                <MenuItem
                    url={''}
                    name={'Statistics'}
                    icon={<FaChartLine />}
                    isSubMenu={true}
                    data-cy="menu-statistic-all"
                >
                    <SubMenuItem url={'/statistics/country'} name={'Country'} data-cy="menu-statistic-country" />
                    <SubMenuItem url={'/statistics/offers'} name={'Offers'} data-cy="menu-statistic-offers" />
                    <SubMenuItem url={'/statistics/active-users'} name={'Active users'} data-cy="menu-statistic-active-users" />
                </MenuItem>
            )}
            {hasAccessRight(AdminAclEnum.COMPANY) && (
                <MenuItem url={'/company'} name={'Company'} icon={<FaBuilding />} data-cy="menu-company" />
            )}

            {hasAccessRight(AdminAclEnum.INVOICES) && (
                <MenuItem
                    url={''}
                    name={'Invoices'}
                    icon={<FaFileInvoiceDollar />}
                    isSubMenu={true}
                    data-cy="menu-invoices"
                >
                    <SubMenuItem url={'/invoices/v2'} name={'Invoices'} data-cy="menu-invoices" />
                    <SubMenuItem url={'/invoices/contracts'} name={'Long term invoices'} data-cy="menu-long-invoices" />
                    {hasAccessRight(AdminAclEnum.INVOICE_VERIFICATION) ? (
                        <SubMenuItem
                            url={'/invoices/contracts-verify'}
                            name={'Rejected long term invoices'}
                            data-cy="menu-rejected-long-invoices"
                        />
                    ) : (
                        <></>
                    )}
                    {hasAccessRight(AdminAclEnum.INVOICE_VERIFICATION) ? (
                        <SubMenuItem
                            url={'/invoices/verify'}
                            name={'Rejected invoices'}
                            data-cy="menu-rejected-invoices"
                        />
                    ) : (
                        <></>
                    )}
                </MenuItem>
            )}
            {hasAccessRight(AdminAclEnum.PLATFORM) && (
                <MenuItem
                    url={''}
                    name={'Platform'}
                    icon={<FaInstagram />}
                    isSubMenu={true}
                    data-cy="menu-platform-all"
                >
                    <SubMenuItem url={'/platform/platforms'} name="Platforms" data-cy="menu-platforms" />
                    <SubMenuItem url={'/platform/item'} name="Platforms item" data-cy="menu-platforms-item" />
                </MenuItem>
            )}
            {(hasAccessRight(AdminAclEnum.REPORT_ITEMS) || hasAccessRight(AdminAclEnum.REPORTING)) && (
                <MenuItem url={''} name={'Reporting'} icon={<FaReply />} isSubMenu={true} data-cy="menu-reporting-all">
                    <>
                        {hasAccessRight(AdminAclEnum.REPORT_ITEMS) && (
                            <>
                                <SubMenuItem url="/reporting/approved" name="Reports" data-cy="menu-reports" />
                                <SubMenuItem
                                    url="/reporting/rejected"
                                    name="Rejected Reports"
                                    data-cy="menu-rejected-reports"
                                />
                            </>
                        )}

                        {hasAccessRight(AdminAclEnum.REPORTING) && (
                            <SubMenuItem url="/reporting/overview" name="Overview" data-cy="menu-reporting-overview" />
                        )}
                    </>
                </MenuItem>
            )}

            {hasAccessRight(AdminAclEnum.DISCOVERY) && (
                <MenuItem url={''} name="Discovery" icon={<FaSearch />} isSubMenu={true} data-cy="menu-discovery-all">
                    <SubMenuItem
                        url="/discovery/overview"
                        name="Discovery overview"
                        data-cy="menu-discovery-overview"
                    />
                </MenuItem>
            )}
            {hasAccessRight(AdminAclEnum.CONTROLLING) && (
                <MenuItem
                    url={''}
                    name="Controlling"
                    icon={<FaChartBar />}
                    isSubMenu={true}
                    data-cy="menu-controlling-all"
                >
                    {hasAccessRight(AdminAclEnum.CONTROLLING_INCOMING_DEFERRAL) ? (
                        <SubMenuItem
                            url="/controlling/incoming-deferral"
                            name="Incoming deferral"
                            data-cy="menu-controlling-incoming-deferral"
                        />
                    ) : (
                        <></>
                    )}
                    {hasAccessRight(AdminAclEnum.CONTROLLING_INCOMING_INVOICES) ? (
                        <SubMenuItem
                            url="/controlling/incoming-invoices"
                            name="Incoming invoices"
                            data-cy="menu-controlling-incoming-invoices"
                        />
                    ) : (
                        <></>
                    )}
                    {hasAccessRight(AdminAclEnum.CONTROLLING_OUTGOING_INVOICES) ? (
                        <SubMenuItem
                            url="/controlling/workspace-revenue"
                            name="Workspace revenue"
                            data-cy="menu-controlling-workspace-revenue"
                        />
                    ) : (
                        <></>
                    )}
                    {hasAccessRight(AdminAclEnum.CONTROLLING_LONG_TERM_INCOMING_INVOICES) ? (
                        <SubMenuItem
                            url="/controlling/long-term-incoming-invoices"
                            name="Long term incoming invoices"
                            data-cy="menu-controlling-long-term-incoming-invoices"
                        />
                    ) : (
                        <></>
                    )}
                    {hasAccessRight(AdminAclEnum.CONTROLLING_KPIS) ? (
                        <SubMenuItem
                            url="/controlling/deferral-list"
                            name="Deferral list"
                            data-cy="menu-controlling-long-term-incoming-invoices"
                        />
                    ) : (
                        <></>
                    )}
                    {hasAccessRight(AdminAclEnum.CONTROLLING_AGENCY_REVENUE_CAMPAIGNS) ? (
                        <SubMenuItem
                            url="/controlling/agency-revenue-campaings"
                            name="Agency revenue campaigns"
                            data-cy="menu-controlling-agency-revenue-campaings"
                        />
                    ) : (
                        <></>
                    )}
                    {hasAccessRight(AdminAclEnum.CONTROLLING_AGENCY_REVENUE_COMPANIES) ? (
                        <SubMenuItem
                            url="/controlling/agency-margins-companies"
                            name="Agency margins companies"
                            data-cy="menu-controlling-agency-margins-companies"
                        />
                    ) : (
                        <></>
                    )}
                </MenuItem>
            )}
            {hasAccessRight(AdminAclEnum.LOGS) ? (
                <MenuItem url={''} name="Logs" icon={<FaClipboardList />} isSubMenu={true} data-cy="menu-logs-all">
                    {hasAccessRight(AdminAclEnum.DISCOVERY) ? (
                        <SubMenuItem
                            url="/discovery/search"
                            name="Discovery search"
                            data-cy="menu-discovery-search-log"
                        />
                    ) : (
                        <></>
                    )}
                    {hasAccessRight(AdminAclEnum.DISCOVERY) ? (
                        <SubMenuItem
                            url="/discovery/profile"
                            name="Discovery profile"
                            data-cy="menu-discovery-profile-log"
                        />
                    ) : (
                        <></>
                    )}
                    {hasAccessRight(AdminAclEnum.USER_PLATFORM_LOGS) ? (
                        <SubMenuItem
                            url="/user/platform/logs"
                            name="User platform logs"
                            data-cy="menu-user-platform-log"
                        />
                    ) : (
                        <></>
                    )}
                    {hasAccessRight(AdminAclEnum.PACKAGES) ? (
                        <SubMenuItem
                            url={'/packages/log-packages'}
                            name={'Packages logs'}
                            data-cy="menu-packages-packages"
                        />
                    ) : (
                        <></>
                    )}
                </MenuItem>
            ) : null}
            {hasAccessRight(AdminAclEnum.DISCOVERY_PRESET) && (
                <MenuItem
                    url={'/discovery-preset'}
                    name={'Discovery preset filters'}
                    icon={<FaFilter />}
                    data-cy="menu-discovery-preset"
                />
            )}
        </ul>
    );
}
